import clickEvents from '../index'

export const getClickEvent = (eventName = '') =>
  clickEvents[eventName] || undefined
